import { Logger } from '@wix/wix-log';
var METHODS = /*#__PURE__*/function (METHODS) {
  METHODS["GET"] = "get";
  METHODS["POST"] = "post";
  return METHODS;
}(METHODS || {});
const logger = new Logger('PackagePickerAutonomousApiConfig');
const {
  GET,
  POST
} = METHODS;
const isDev = process.env.NODE_ENV === 'development' && window.location.href.includes('localhost');
const urlSearchParams = new URLSearchParams(window.location.search);
const xWixRoute = urlSearchParams.get('x-wix-route');
if (xWixRoute) {
  logger.withData({
    xWixRoute
  }).info('Overriding x-wix-route with query param');
}
const useProductionApi = !isDev || urlSearchParams.get('useProductionApi') === 'true';
const apiBaseUrl = useProductionApi ? '/premium-purchase-plan' : 'http://localhost:3000';
const PackagePickerService = {
  name: 'PackagePickerService',
  baseUrl: `${apiBaseUrl}/api/v1`,
  defaultHttpMethod: POST,
  requestOptions: {
    headers: {
      contentType: 'application/json'
    }
  },
  requestTransform: req => {
    if (xWixRoute) {
      return {
        ...req,
        'x-wix-route': xWixRoute
      };
    }
    return req;
  }
};
export const PackagePickerApiMethodsConfig = {
  pageTitles: {
    name: 'pageTitles',
    service: PackagePickerService,
    path: '/pageTitles/:packagePickerType',
    httpMethod: GET
  },
  promotedProductFeatures: {
    name: 'promotedProductFeatures',
    service: PackagePickerService,
    path: '/promotedProductFeatures/:packagePickerType',
    httpMethod: POST
  },
  acceptedPaymentMethods: {
    name: 'acceptedPaymentMethods',
    service: PackagePickerService,
    path: '/acceptedPaymentMethods',
    httpMethod: GET
  },
  offering: {
    name: 'offering',
    service: PackagePickerService,
    path: '/offering/:packagePickerType',
    httpMethod: GET
  },
  recommendedProductFamily: {
    name: 'recommendedProductFamily',
    service: PackagePickerService,
    path: '/recommendedProductFamily/:packagePickerType',
    httpMethod: GET
  },
  productFeatureDetails: {
    name: 'productFeatureDetails',
    service: PackagePickerService,
    path: '/productFeatureDetails/:packagePickerType',
    httpMethod: POST
  },
  promotionalContent: {
    name: 'promotionalContent',
    service: PackagePickerService,
    path: '/promotionalContent/:packagePickerType/:contentType',
    httpMethod: POST
  },
  userSessionDetails: {
    name: 'userSessionDetails',
    service: PackagePickerService,
    path: '/userSessionDetails',
    httpMethod: GET
  },
  faqs: {
    name: 'faqs',
    service: PackagePickerService,
    path: '/faqs/:packagePickerType',
    httpMethod: GET
  },
  sale: {
    name: 'sale',
    service: PackagePickerService,
    path: '/sale/:packagePickerType',
    httpMethod: GET
  }
};
//# sourceMappingURL=apiConfig.js.map